var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('compute.disk_backup')}}),_c('page-body',[_c('disk-backup-list',{attrs:{"id":_vm.listId,"tableOverviewIndexs":_vm.tableOverviewIndexs,"statusResKey":"diskBackup"},on:{"resStatisticsChange":_vm.resStatisticsChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }